// React i hooks
import { memo, useCallback } from "react";

// Tipovi i konstante
import { PublicApiStatusCardProps } from "./types";

// UI komponente
import Switch from "ui/components/Switch/Switch";
import Badge from "ui/components/Badge/Badge";
import Alert from "ui/components/Alert/Alert";

/** Prekidač javnog API-ja (opt-in). Stanje dolazi iz poslužitelja, pa nema lokalne kopije. */
const PublicApiStatusCard: React.FC<PublicApiStatusCardProps> = (props) => {
  const { settings, isSaving, onEnabledChange } = props;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onEnabledChange(e.target.checked);
    },
    [onEnabledChange]
  );

  const activeKeyCount = settings.keys.filter((key) => !key.isExpired).length;

  return (
    <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
      <div className="flex flex-col flex-1 max-w-[300px]">
        <p className="text-base font-bold text-slate-600 py-3">Javni API</p>
        <p className="text-sm">
          Objava vozila na vašoj web stranici. Stranica podatke dobiva kroz javni API servis
          koji se Orytronu predstavlja API ključem — ključevi su ispod.
        </p>
      </div>

      <div className="flex flex-col flex-1 px-3 my-3 gap-3">
        <div className="flex items-center gap-4">
          <Switch
            name="enabled"
            checked={settings.enabled}
            onChange={handleChange}
            disabled={isSaving}
            labelRight={settings.enabled ? "Uključen" : "Isključen"}
          />
          <Badge
            text={settings.enabled ? "Aktivan" : "Neaktivan"}
            variant={settings.enabled ? "success" : "secondary"}
            height="small"
            showDot
          />
        </div>

        <p className="text-xs text-slate-500 max-w-xl">
          Dok je isključen, nijedan ključ ne vrijedi — ni već izdani. Isključivanje ne briše
          ključeve, pa se objava može privremeno zaustaviti i ponovno uključiti bez promjene na
          web stranici.
        </p>

        {settings.enabled && activeKeyCount === 0 && (
          <div className="max-w-xl">
            <Alert
              variant="warning"
              message="Javni API je uključen, ali nema nijednog valjanog ključa. Izdajte ključ da bi web stranica dobila pristup."
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(PublicApiStatusCard);
